var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-row',{directives:[{name:"show",rawName:"v-show",value:(
    _vm.$root.listFoodSelected.length === 0 &&
      _vm.$root.loadingFood === false &&
      _vm.props.loading === false
  ),expression:"\n    $root.listFoodSelected.length === 0 &&\n      $root.loadingFood === false &&\n      props.loading === false\n  "}],staticClass:"local-carta-loader"},[_c('f7-col',[_c('f7-button',{attrs:{"raise":""}},[_c('i',{staticClass:"fas fa-warning"}),_vm._v("   No hay Platos Disponibles\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }